<template>
  <div>
    <div class="tab-plan verify-tab">
      <div v-if="isShowMemberInfo" class="verify-form">
        <section class="settings-info-card">
          <div class="verify-form-title">
            {{ $t('Bao.personal_info') }}
          </div>
          <p class="settings-info-description">
            {{ $t('Bao.personal_info_desc') }}
          </p>

          <div class="row-frame gx-3 gy-3">
            <div class="colu colu-12 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400" for="nationality">
                {{ $t('Bao.nationality') }}
                <span class="t-highlight">＊</span>
              </label>
              <!-- 已設定國籍：不可修改，直接顯示國籍名稱（下拉選單項目可能不含該國籍而顯示空白） -->
              <input
                v-if="memberInfo.nationality"
                id="nationality"
                class="for-input inpType"
                type="text"
                :value="nationalityName"
                disabled
              >
              <select
                v-else
                id="nationality"
                v-model="updateUser.nationality"
                v-validate="'required'"
                class="for-input"
                :class="{ 'isInvalid': errors.has('nationality') }"
                name="nationality"
                :data-vv-as="$t('Bao.nationality')"
              >
                <option value="">
                  {{ $t('Bao.please_select') }}
                </option>
                <option
                  v-for="item in nationalityOptions"
                  :key="item.code"
                  :value="item.code"
                >
                  {{ item.name }}
                </option>
              </select>
              <div v-if="errors.has('nationality')" class="input-feedback text-align-R">
                {{ $t('Bao.nationality_error') }}
              </div>
            </div>
          </div>

          <!-- 未選國籍前隱藏姓名欄，先引導選國籍 -->
          <div class="name-entry-guide" :class="{ 'is-ready': !!updateUser.nationality }">
            <div class="name-entry-guide-title">
              {{ $t('Bao.name_entry_guide_title') }}
            </div>
            <p v-if="!updateUser.nationality" class="name-entry-guide-copy">
              {{ $t('Bao.name_entry_guide_select_nationality') }}
            </p>
            <span class="name-entry-guide-note">{{ $t('Bao.name_entry_guide_note') }}</span>
          </div>

          <div v-if="updateUser.nationality" class="row-frame gx-3 gy-3 name-fields-grid">
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <name-field-label class="colu-12 for-label" :field="nameFields.nameLast" :required="nameRequired" />
              <template v-if="memberInfo.name">
                <input
                  v-model="lastName"
                  class="for-input inpType"
                  type="text"
                  disabled
                >
              </template>
              <template v-else>
                <input
                  v-model="lastName"
                  v-validate="nameRequired ? 'required' : ''"
                  class="for-input inpType"
                  :class="{ 'isInvalid': errors.has('last_name')}"
                  type="text"
                  name="last_name"
                  :data-vv-as="$t('Bao.last_name')"
                  :placeholder="$t('Bao.name_content')"
                  @input="validateNameLast"
                >
              </template>
              <div v-if="errors.has('last_name')" class="input-feedback text-align-R">
                {{ $t('Bao.last_name_error') }}
              </div>
            </div>
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <name-field-label class="colu-12 for-label" :field="nameFields.nameFirst" :required="nameRequired" />
              <template v-if="memberInfo.name">
                <input
                  v-model="firstName"
                  type="text"
                  class="for-input inpType"
                  disabled
                >
              </template>
              <template v-else>
                <input
                  v-model="firstName"
                  v-validate="nameRequired ? 'required' : ''"
                  class="for-input inpType"
                  :class="{ 'isInvalid': errors.has('first_name')}"
                  type="text"
                  name="first_name"
                  :data-vv-as="$t('Bao.first_name')"
                  :placeholder="$t('Bao.name_content')"
                  @input="validateNameFirst"
                >
              </template>
              <div v-if="errors.has('first_name')" class="input-feedback text-align-R">
                {{ $t('Bao.first_name_error') }}
              </div>
            </div>
            <template v-if="!isTheme('theme_blue')">
              <div class="colu colu-12 colu-lg-6 flex-colu">
                <name-field-label class="colu-12 for-label" :field="nameFields.romLast" />
                <template v-if="memberInfo.romanization">
                  <input
                    v-model="romanizationOfLastName"
                    type="text"
                    class="for-input inpType"
                    disabled
                  >
                </template>
                <template v-else>
                  <input
                    v-model="romanizationOfLastName"
                    v-validate="'required'"
                    class="for-input inpType"
                    :class="{ 'isInvalid': errors.has('romanizationOfLastName') || romanLastError }"
                    type="text"
                    name="romanizationOfLastName"
                    :data-vv-as="$t('Bao.romanization_of_last_name')"
                    :placeholder="$t('Bao.name_content')"
                    @input="validateRomLastName"
                  >
                </template>
                <div v-if="errors.has('romanizationOfLastName')" class="input-feedback text-align-R">
                  {{ $t('Bao.romanization_of_last_name_error') }}
                </div>
                <div v-else-if="romanLastError" class="input-feedback text-align-R">
                  {{ romanLastError }}
                </div>
              </div>
              <div class="colu colu-12 colu-lg-6 flex-colu">
                <name-field-label class="colu-12 for-label" :field="nameFields.romFirst" />
                <template v-if="memberInfo.romanization">
                  <input
                    v-model="romanizationOfFirstName"
                    class="for-input inpType"
                    type="text"
                    disabled
                  >
                </template>
                <template v-else>
                  <input
                    v-model="romanizationOfFirstName"
                    v-validate="'required'"
                    class="for-input inpType"
                    :class="{ 'isInvalid': errors.has('romanizationOfFirstName') || romanFirstError }"
                    type="text"
                    name="romanizationOfFirstName"
                    :data-vv-as="$t('Bao.romanization_of_first_name')"
                    :placeholder="$t('Bao.name_content')"
                    @input="validateRomFirstName"
                  >
                </template>
                <div v-if="errors.has('romanizationOfFirstName')" class="input-feedback text-align-R">
                  {{ $t('Bao.romanization_of_first_name_error') }}
                </div>
                <div v-else-if="romanFirstError" class="input-feedback text-align-R">
                  {{ romanFirstError }}
                </div>
              </div>
            </template>
          </div>

          <div class="row-frame gx-3 gy-3">
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400">
                {{ $t("Bao.birthday") }}
                <span class="t-highlight">＊</span>
              </label>
              <template v-if="memberInfo.birthday">
                <input
                  type="text"
                  class="for-input inpType"
                  :value="memberInfo.birthday"
                  disabled
                >
              </template>
              <template v-else>
                <input
                  v-model="updateUser.birthday"
                  v-validate="'required|date_format:yyyy-MM-dd|before:' + maxDate"
                  class="for-input inpType"
                  :class="{ 'isInvalid': errors.has('birthday') }"
                  type="date"
                  name="birthday"
                  :data-vv-as="$t('Bao.birthday')"
                  :max="maxDate"
                >
              </template>
              <div v-if="errors.has('birthday')" class="input-feedback text-align-R">
                {{ $t('Bao.birthday_error') }}
              </div>
            </div>
            <div class="colu colu-12 colu-lg-6 flex-colu">
              <label class="colu-12 for-label fs-14px fw-400">
                {{ $t("Bao.address") }}
                <span class="t-highlight">＊</span>
              </label>
              <input
                v-model="updateUser.address"
                v-validate="'required'"
                class="for-input inpType"
                :class="{ 'isInvalid': errors.has('address') }"
                type="text"
                name="address"
                :placeholder="pleaseEnterTip('address')"
                :disabled="memberInfo.is_pass_KYC === 1"
              >
              <div v-if="errors.has('address')" class="input-feedback text-align-R">
                {{ $t('Bao.address_error') }}
              </div>
            </div>
          </div>
        </section>

        <section class="settings-info-card">
          <div class="verify-form-title">
            {{ $t("Bao.contact_info") }}
          </div>
          <p class="settings-info-description">
            {{ $t('Bao.contact_info_desc') }}
          </p>
          <div class="row-frame gx-3">
            <div class="colu-12">
              <label class="colu-12 for-label fs-14px fw-400" for="メールアドレス">{{ $t("Bao.e-mail") }}
                <span class="t-highlight">＊</span>
              </label>
            </div>
            <div class="colu" :class="emailNeedVerify ? 'colu-8 colu-md-9 colu-lg-10' : 'colu-12'">
              <input
                v-if="memberInfo.email_validate === 0"
                id="eMail"
                v-model="updateUser.email"
                v-validate="'required'"
                class="for-input inpType"
                type="email"
                name="email"
                :placeholder="memberInfo.email"
              >
              <input
                v-else
                id="eMail"
                class="for-input inpType"
                type="text"
                name="check_lite_email"
                :value="memberInfo.email"
                :disabled="memberInfo.email_validate === 1"
              >
            </div>
            <div v-if="emailNeedVerify" class="colu colu-4 colu-md-3 colu-lg-2">
              <button
                :disabled="memberInfo.email_validate === 1 && updateUser.email"
                class="btn btn-settings set-email btn-stroke button-style flex-fill"
                @click="goVerifyEmail"
              >
                {{ $t("Bao.verify_register") }}
              </button>
            </div>
          </div>

          <div class="row-frame gx-3">
            <div class="colu-12">
              <label class="colu-12 for-label fs-14px fw-400" for="メールアドレス">{{ $t("Bao.phone") }}
                <span class="t-highlight">＊</span>
              </label>
            </div>
            <div class="country-select-frame" :class="phoneNeedVerify ? 'colu-8 colu-md-9 colu-lg-10' : 'colu-12'">
              <div class="colu">
                <div class="colu-4 colu-sm-3 colu-lg-2 country-select-box" :class="{ active: isActive }" @click="toggleActive">
                  <div class="form-select-1 country-select">
                    <div class="form-select-value">
                      <div class="country-flag" />
                      <div class="country-code">
                        {{ selectedCode }}
                      </div>

                      <div class="country-list-box">
                        <ul class="country-list">
                          <li
                            v-for="(code, key) in brand.supportPhoneCode"
                            :key="key"
                            @click.stop="selectCode(code)"
                          >
                            <div class="country-flag" />
                            <div class="country-code">
                              {{ code }}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <i class="fa-solid fa-angle-right " aria-hidden="true" />
                </div>
                <div class="colu-8 colu-sm-9 colu-lg-10 number-box">
                  <input
                    v-if="memberInfo.phone_validate === 0"
                    id="phoneNumber"
                    v-model="phone"
                    v-validate="'required'"
                    class="colu-12 for-input inpType"
                    :class="{ 'isInvalid': phoneError && phoneError !== $t('Bao.phone_available') }"
                    type="text"
                    autocomplete="off"
                    @input="phonecheck"
                  >
                  <input
                    v-if="memberInfo.phone_validate === 1"
                    id="phoneNumber"
                    :placeholder="updateUser.phone"
                    type="text"
                    class="colu-12 for-input inpType"
                    disabled
                  >
                  <div v-if="phoneError === $t('Bao.phone_available')" class="account_good text-align-R">
                    {{ phoneError }}
                  </div>
                  <div v-else-if="phoneError" class="input-feedback text-align-R">
                    {{ phoneError }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="phoneNeedVerify" class="colu colu-4 colu-md-3 colu-lg-2">
              <button
                :disabled="memberInfo.phone_validate === 1 && updateUser.phone"
                class="btn btn-settings set-email btn-stroke button-style flex-fill"
                @click="goVerifyPhone"
              >
                {{ $t("Bao.verify_register") }}
              </button>
            </div>
          </div>
        </section>
      </div>
      <div v-if="isShowMemberInfo || isShowKYC" class="row-frame gy-3">
        <div class="colu colu-12">
          <button
            :disabled="isSendButtonDisabled"
            class="btn btn-tertiary flex-fill"
            @click="save()"
          >
            <template v-if="isShowKYC && kyc_brand && memberInfo.is_pass_KYC !== 1">
              {{ $t("Bao.KYC_has_third_completed_btn") }}
            </template>
            <template v-else-if="memberInfo.is_pass_KYC === 0">
              <!-- 站台不需 KYC 時，不會進入 KYC 流程 -->
              {{ isShowKYC ? $t("Bao.next") : $t("Bao.confirm_member_info") }}
            </template>
            <template v-else>
              {{ $t("Bao.save_setting") }}
            </template>
          </button>
        </div>
      </div>

      <!-- 聯絡資訊 驗證彈窗 -->
      <div
        v-if="isShowVerifyEmail || isShowVerifyPhone"
        class="popup-wrap register-wrap fun-sec-authen"
        :class="{ active: isShowVerifyEmail || isShowVerifyPhone }"
      >
        <div class="popup-box fullScreen-md">
          <a class="popup-close" @click="closeVerify"><i class="fa-solid fa-xmark" /></a>
          <div class="form-popup popup-padding">
            <form class="row-frame dep-form-frame reg-popupBox">
              <h4 class="register-title font-w-b text-align-L">
                <template v-if="isShowVerifyEmail">
                  {{ $t("Bao.verify_email") }}
                </template>
                <template v-if="isShowVerifyPhone">
                  {{ $t("Bao.verify_phone") }}
                </template>
              </h4>
              <div class="reg-form-group">
                <div class="reg-form-area">
                  <div class="colu colu-auto">
                    <label class="colu-12 colu-form-label title-label let-lessen">
                      <template v-if="isShowVerifyEmail">
                        {{ $t("Bao.verify_email_code") }}
                      </template>
                      <template v-if="isShowVerifyPhone">
                        {{ $t("Bao.verify_phone_code") }}
                      </template>
                    </label>
                    <div class="colu-12">
                      <input
                        v-if="isShowVerifyEmail"
                        v-model="verifyEmailCode"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': shouldShowEmailError}"
                        type="text"
                        name="emailValidateCode"
                        autocomplete="off"
                        @input="validateEmailCode"
                      >
                      <input
                        v-if="isShowVerifyPhone"
                        v-model="verifyPhoneCode"
                        class="colu-12 for-input inpType"
                        :class="{ 'isInvalid': shouldShowPhoneError}"
                        type="text"
                        name="phoneValidateCode"
                        autocomplete="off"
                        @input="validatePhoneCode"
                      >
                    </div>
                    <div v-if="shouldShowEmailError || shouldShowPhoneError" class="input-feedback text-align-R">
                      {{ $t("Bao.validate_code_error") }}
                    </div>
                  </div>
                  <div>
                    <div class="form-button form-ft">
                      <button
                        class="btn btn-tertiary"
                        :disabled="isShowVerifyEmail ? isMailButtonDisabled : isPhoneButtonDisabled"
                        @click.prevent="isShowVerifyEmail ? verifyMail() : verifyPhone()"
                      >
                        <span>{{ $t("Bao.verify_register") }}</span>
                      </button>
                    </div>
                  </div>
                  <div class="colu-auto">
                    <i class="icon-alert">
                      <img :src="$getThemeImagePath('icon-detail.png')" alt="">
                    </i>
                    <b>{{ $t("Bao.email_notice_4") }}</b>
                    <span v-if="isShowVerifyEmail" class="let-lessen">{{ $t("Bao.email_notice_5") }}</span>
                    <span v-if="isShowVerifyPhone" class="let-lessen">{{ $t("Bao.phone_notice_5") }}</span>
                  </div>
                  <div class="colu-auto">
                    <b>{{ $t("Bao.email_notice_1") }}</b>
                  </div>
                  <div class="colu-auto">
                    <p v-if="isShowVerifyEmail">
                      {{ $t("Bao.email_notice_2") }} {{ $t("Bao.email_notice_3") }}
                    </p>
                    <p v-if="isShowVerifyPhone">
                      {{ $t("Bao.phone_notice_3") }}
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <div class="authen-btn-wrap">
                  <button
                    class="btn-primary goTo-fun-sec-authen btn-mb-w-100 btn-resend"
                    :disabled="timerCount"
                    @click="getVerificationPop"
                  >
                    <i v-show="timerCount" class="fa fa-spinner fa-pulse fa-fw" />
                    <span>{{ timerCount ? '' + limitSecond + 's' : $t('Bao.get_verification_code') }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <iframe-verify v-if="verifyUrlFromStore" />
    </div>
  </div>
</template>

<script>
import { update, getPhoneCode, verifyPhoneCode, getEmailCode, verifyEmailCode, phoneCheck, getThirdPartyKycUrl } from '@/api/user'
import { setErrorMessage, showNotice, showRestrictedAccountError } from '@/utils/tool'
import { getNationalityOptions, getNationalityName, sanitizeNameField, getNameFields, isNameFieldRequired } from '@/utils/nationality'
import iframeVerify from '@/components/modal/iframeGame'
import nameFieldLabel from '@/components/nameFieldLabel'
import { mapGetters } from 'vuex'
import themeMixin from '@/mixins/themeMixin'

export default {
  components: {
    iframeVerify,
    nameFieldLabel
  },
  mixins: [themeMixin],
  data() {
    return {
      updateUser: {},
      romanizationOfLastName: '',
      romanizationOfFirstName: '',
      romanLastError: '',
      romanFirstError: '',
      lastName: '',
      firstName: '',
      maxDate: new Date().toISOString().split('T')[0],
      isShowVerifyPhone: false,
      phone: '',
      verifyPhoneCode: '',
      isShowVerifyEmail: false,
      email: '',
      verifyEmailCode: '',
      timerCount: true,
      limitSecond: 180,
      isPhoneValid: false,
      phoneError: '',
      emailCodeTouched: false,
      phoneCodeTouched: false,
      isActive: false,
      selectedCode: '',
      phoneWithoutCode: ''
    }
  },
  computed: {
    ...mapGetters(['brand', 'user', 'memberInfo', 'permissionInfo', 'socialType', 'showAccountSetting']),
    nationalityOptions() {
      return getNationalityOptions(this.brand.supportNationality)
    },
    nationalityName() {
      return getNationalityName(this.memberInfo.nationality)
    },
    nameFields() {
      return getNameFields(this.updateUser.nationality, {
        nameLast: this.$t('Bao.last_name'),
        nameFirst: this.$t('Bao.first_name'),
        romLast: this.$t('Bao.romanization_of_last_name'),
        romFirst: this.$t('Bao.romanization_of_first_name')
      })
    },
    nameRequired() {
      return isNameFieldRequired(this.updateUser.nationality)
    },
    kyc_brand() {
      return this.brand.info.kyc_brand !== 'self'
    },
    // 後台開關：是否需要驗證信箱 / 手機
    emailNeedVerify() {
      return !!this.permissionInfo.profile_need_email_verify
    },
    phoneNeedVerify() {
      return !!this.permissionInfo.profile_need_phone_verify
    },
    isEmailVerified() {
      return !this.emailNeedVerify || this.memberInfo.email_validate === 1
    },
    isPhoneVerified() {
      return !this.phoneNeedVerify || this.memberInfo.phone_validate === 1
    },
    isSendButtonDisabled() {
      if (!this.isTheme('theme_purple')) {
        return !this.isEmailVerified || !this.isPhoneVerified
      }
      return false
    },
    isMailButtonDisabled() {
      return this.verifyEmailCode === null || this.verifyEmailCode.trim() === ''
    },
    isPhoneButtonDisabled() {
      return this.verifyPhoneCode === null || this.verifyPhoneCode.trim() === ''
    },
    verifyUrlFromStore() {
      return this.$store.state.app.gameUrl
    },
    emailCodeInvalid() {
      return this.verifyEmailCode.trim() === ''
    },
    phoneCodeInvalid() {
      return this.verifyPhoneCode.trim() === ''
    },
    shouldShowEmailError() {
      return this.emailCodeTouched && this.emailCodeInvalid
    },
    shouldShowPhoneError() {
      return this.phoneCodeTouched && this.phoneCodeInvalid
    },
    isShowKYC() {
      return this.permissionInfo.enable_kyc_certification !== 0
    },
    // 是否顯示個資欄位：已與 KYC 開關脫鉤，改吃獨立開關 register_need_member_info（後端預設 1）
    isShowMemberInfo() {
      return this.permissionInfo.register_need_member_info !== 0
    }
  },
  watch: {
    // 個資與 KYC 都關閉時本頁無內容，改到安全中心；品牌資訊為非同步載入，需監聽開關變化
    showAccountSetting: {
      handler(show) {
        if (!show) this.$router.replace('/user/verify').catch(() => {})
      },
      immediate: true
    },
    romanizationOfLastName(newLastName) {
      this.updateUser.romanization = newLastName + ',' + this.romanizationOfFirstName
    },
    romanizationOfFirstName(newFirstName) {
      this.updateUser.romanization = this.romanizationOfLastName + ',' + newFirstName
    },
    lastName(newLastName) {
      this.updateUser.name = newLastName + ',' + this.firstName
    },
    firstName(newFirstName) {
      this.updateUser.name = this.lastName + ',' + newFirstName
    },
    'brand.supportPhoneCode': {
      handler(newVal) {
        if (newVal && newVal.length > 0 && !this.selectedCode) {
          if (this.memberInfo.phone_validate === 1) {
            const matchedCode = newVal.find(code => this.memberInfo.phone.startsWith(code))
            this.selectedCode = matchedCode || ''
          } else if (this.memberInfo.phone_validate === 0 && this.memberInfo.phone) {
            const matchedCode = newVal.find(code => this.memberInfo.phone.startsWith(code))
            this.selectedCode = matchedCode || newVal[0]
          } else {
            this.selectedCode = newVal[0]
          }
        }
      },
      immediate: true
    },
    selectedCode(newCode) {
      if (this.memberInfo.phone && newCode) {
        const oldCode = this.brand.supportPhoneCode.find(code =>
          this.memberInfo.phone.startsWith(code)
        )
        if (oldCode) {
          this.phoneWithoutCode = this.memberInfo.phone.substring(oldCode.length)
        }
      }
    },
    'updateUser.nationality'() {
      this.sanitizeAllNameFields()
    }
  },
  created() {
    this.initUpdateUser()
    this.debounceCheckPhone = this.debounce(this.phoneApiCall, 500)
  },
  methods: {
    openIframe() {
      const kyc_url = this.$store.state.user.kyc_url
      if (kyc_url) {
        this.$store.commit('SET_GAME_URL', kyc_url)
        this.$store.commit('SET_KYC_VERIFY', true)
      } else {
        getThirdPartyKycUrl().then(response => {
          if (response.data.data.code === 0) {
            this.$store.commit('SET_GAME_URL', response.data.data.url)
            this.$store.commit('SET_KYC_VERIFY', true)
          } else {
            showNotice(response.data.data.message)
          }
        }).catch((error) => {
          showNotice(error.response.data.msg)
        })
      }
    },
    debounce: function(func, wait) {
      let timeout
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout)
          func(...args)
        }
        clearTimeout(timeout)
        timeout = setTimeout(later, wait)
      }
    },
    initUpdateUser() {
      this.romanizationOfLastName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[0] : ''
      this.romanizationOfFirstName = this.memberInfo.romanization ? this.memberInfo.romanization.split(',')[1] : ''
      this.lastName = this.memberInfo.name ? this.memberInfo.name.split(',')[0] : ''
      this.firstName = this.memberInfo.name ? this.memberInfo.name.split(',')[1] : ''

      if (this.memberInfo.phone && this.selectedCode) {
        this.phone = this.memberInfo.phone.startsWith(this.selectedCode)
          ? this.memberInfo.phone.substring(this.selectedCode.length)
          : this.memberInfo.phone
      } else {
        this.phone = this.memberInfo.phone
      }

      this.updateUser = {
        romanization: this.memberInfo.romanization,
        name: this.memberInfo.name,
        newPassword: '',
        confirmPassword: '',
        withdrawal_pass: '',
        address: this.memberInfo.address,
        birthday: this.memberInfo.birthday,
        phone: this.phone,
        email: this.memberInfo.email,
        nationality: this.memberInfo.nationality || ''
      }
    },
    // 手機驗證成功後，只重新同步手機欄位，保留使用者尚未儲存的其他個資
    syncPhoneAfterVerify() {
      if (this.memberInfo.phone && this.selectedCode) {
        this.phone = this.memberInfo.phone.startsWith(this.selectedCode)
          ? this.memberInfo.phone.substring(this.selectedCode.length)
          : this.memberInfo.phone
      } else {
        this.phone = this.memberInfo.phone
      }
      this.updateUser.phone = this.phone
    },
    // 信箱驗證成功後，只重新同步信箱欄位，保留使用者尚未儲存的其他個資
    syncEmailAfterVerify() {
      this.email = this.memberInfo.email
      this.updateUser.email = this.memberInfo.email
    },
    phoneApiCall() {
      if (this.phone && this.phone.trim() !== '') {
        phoneCheck({ phone: this.selectedCode + this.phone }).then(res => {
          this.phoneError = this.$t('Bao.phone_available')
          this.isPhoneValid = true
        }).catch(err => {
          console.log(err)
          this.phoneError = this.$t('Bao.phone_error')
          this.isPhoneValid = false
        })
      }
    },
    phonecheck() {
      if (!this.phone) {
        this.phoneError = this.$t('Bao.phone_error')
        this.isPhoneValid = false
      } else {
        this.debounceCheckPhone()
      }
    },
    countDown() {
      const timer = setInterval(() => {
        if (this.limitSecond > 0) {
          this.limitSecond--
        } else {
          this.timerCount = false
          this.limitSecond = 180
          clearInterval(timer)
        }
      }, 1000)
    },
    getVerificationPop() {
      if (this.isShowVerifyEmail) {
        this.goVerifyEmail()
        return
      } else {
        this.goVerifyPhone()
      }
    },
    closeVerify() {
      this.isShowVerifyEmail = false
      this.isShowVerifyPhone = false
    },
    goVerifyPhone() {
      // 第三方登入的帳號不可變更已驗證的手機（尚未綁定者可新增）
      if (this.socialType && this.socialType !== 'account' && this.memberInfo.phone_validate === 1) {
        showNotice(this.$t('Bao.phone_email_cannot_change'))
        return
      }
      getPhoneCode({ phone: this.selectedCode + this.phone }).then(response => {
        // 第三方帳號：後端可能以 200 回應 data.code=14
        if (showRestrictedAccountError(response)) {
          return
        }
        this.countDown()
        showNotice(response.data.msg)
        this.isShowVerifyPhone = true
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
      })
    },
    verifyPhone() {
      verifyPhoneCode(
        {
          phone: this.selectedCode + this.phone,
          validateCode: this.verifyPhoneCode
        }
      ).then(response => {
        if (showRestrictedAccountError(response)) {
          return
        }
        this.isShowVerifyPhone = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.syncPhoneAfterVerify()
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
      })
    },
    goVerifyEmail() {
      // 第三方登入的帳號不可變更已驗證的信箱（尚未綁定者可新增）
      if (this.socialType && this.socialType !== 'account' && this.memberInfo.email_validate === 1) {
        showNotice(this.$t('Bao.phone_email_cannot_change'))
        return
      }
      if (!this.updateUser.email && this.memberInfo.email) {
        this.updateUser.email = this.memberInfo.email
      }

      this.email = this.updateUser.email
      this.getMailCode(this.email)
    },
    getMailCode(mail) {
      getEmailCode({ email: mail }).then(response => {
        // 第三方帳號：後端可能以 200 回應 data.code=14
        if (showRestrictedAccountError(response)) {
          return
        }
        this.isShowVerifyEmail = true
        this.countDown()
        showNotice(response.data.msg)
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
        this.isShowVerifyEmail = false
      })
    },
    verifyMail() {
      verifyEmailCode({ email: this.email, validateCode: this.verifyEmailCode }).then(response => {
        if (showRestrictedAccountError(response)) {
          return
        }
        this.isShowVerifyEmail = false
        showNotice(this.$t('Bao.update_success'))
        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.syncEmailAfterVerify()
      }).catch((error) => {
        if (!showRestrictedAccountError(error)) {
          showNotice(error.response.data.msg)
        }
      })
    },
    save() {
      // lite player 只需輸入提款密碼即可保存
      if (this.memberInfo.member_type === 3) {
        if (this.emailNeedVerify) {
          this.updateUser.email = this.email
        }
        const selectedCode = this.isTheme('theme_purple') ? '' : this.selectedCode
        this.updateUser.phone = selectedCode + this.phone
        update(this.updateUser).then(response => {
          if (showRestrictedAccountError(response)) {
            return
          }
          showNotice(this.$t('Bao.update_success'))
          this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
          this.initUpdateUser()
        }).catch((error) => {
          if (!showRestrictedAccountError(error)) {
            setErrorMessage(error.response, this.errors)
          }
        })
      } else {
        this.$validator.validateAll().then(valid => {
          if (valid) {
            // 漢字欄非必填時（日本國籍）可能完全沒輸入過，仍送出「,」讓姓名欄位視為已填寫
            if (!this.memberInfo.name) {
              this.updateUser.name = this.lastName + ',' + this.firstName
            }
            if (this.emailNeedVerify) {
              this.updateUser.email = this.email
            }
            const selectedCode = this.isTheme('theme_purple') ? '' : this.selectedCode
            this.updateUser.phone = selectedCode + this.phone

            update(this.updateUser).then(response => {
              if (showRestrictedAccountError(response)) {
                return
              }
              // 站台不需 KYC 或已通過 KYC：僅提示更新成功，不導向 KYC 頁面
              if (!this.isShowKYC || this.memberInfo.is_pass_KYC === 1) {
                showNotice(this.$t('Bao.update_success'))
              } else if (this.kyc_brand && this.memberInfo.is_pass_KYC !== 1) {
                this.openIframe()
              } else if (!this.kyc_brand) {
                this.$router.push('/user/KYC')
              }

              this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
              this.initUpdateUser()
            }).catch((error) => {
              if (!showRestrictedAccountError(error)) {
                setErrorMessage(error.response, this.errors)
              }
            })
          }
        })
      }
    },
    pleaseEnterTip(filed) {
      return this.$t('Bao.' + filed) + this.$t('Bao.please_input')
    },
    validateRomLastName(e) {
      if (e && e.isComposing) return
      this.romanizationOfLastName = sanitizeNameField(this.romanizationOfLastName, this.updateUser.nationality, 'romanization')
    },
    validateRomFirstName(e) {
      if (e && e.isComposing) return
      this.romanizationOfFirstName = sanitizeNameField(this.romanizationOfFirstName, this.updateUser.nationality, 'romanization')
    },
    validateNameLast(e) {
      if (e && e.isComposing) return
      this.lastName = sanitizeNameField(this.lastName, this.updateUser.nationality, 'name')
    },
    validateNameFirst(e) {
      if (e && e.isComposing) return
      this.firstName = sanitizeNameField(this.firstName, this.updateUser.nationality, 'name')
    },
    sanitizeAllNameFields() {
      this.validateRomLastName()
      this.validateRomFirstName()
      this.validateNameLast()
      this.validateNameFirst()
    },
    validateEmailCode() {
      this.emailCodeTouched = true
    },
    validatePhoneCode() {
      this.phoneCodeTouched = true
    },
    toggleActive() {
      if (this.memberInfo.phone_validate === 1) {
        return
      }

      this.isActive = !this.isActive
    },
    selectCode(code) {
      if (this.memberInfo.phone_validate === 1) {
        return
      }

      this.isActive = false
      this.selectedCode = code

      if (this.phone && this.phone.trim() !== '') {
        this.debounceCheckPhone()
      }
    }
  }
}
</script>
